import { useEffect, useRef, useState } from 'react';

export default function SpecialEvent() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="relative py-20 sm:py-32 bg-[#0A0A0A] overflow-hidden">
      {/* 배경 그라데이션 */}
      <div className="absolute inset-0 bg-gradient-to-b from-red-500/10 via-transparent to-transparent"></div>
      
      <div className={`relative max-w-[1600px] mx-auto px-4 sm:px-8 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`}>
        {/* 강한 일본어 대형 배너 */}
        <div className="relative rounded-3xl sm:rounded-[2.5rem] overflow-hidden bg-gradient-to-br from-[#1A1A1A] to-[#0F0F0F] border border-red-500/30">
          {/* 배경 이미지 */}
          <div className="absolute inset-0">
            <img 
              src="https://public.readdy.ai/ai/img_res/5a2414de8f8cd1b0efbcb5132e08503c.jpg" 
              alt="강한 일본어" 
              className="w-full h-full object-cover object-center"
              crossOrigin="anonymous"
              onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/80"></div>
            <div className="absolute inset-0 bg-gradient-to-b from-red-500/20 via-transparent to-red-500/20"></div>
          </div>

          {/* 콘텐츠 */}
          <div className="relative z-10 py-16 sm:py-24 px-6 sm:px-12 lg:px-20">
            <div className="max-w-4xl mx-auto text-center">
              {/* 배지 */}
              <div className="inline-block px-6 sm:px-8 py-2.5 sm:py-3 bg-gradient-to-r from-red-500/20 to-red-600/20 border-2 border-red-500 rounded-full mb-6 sm:mb-8 backdrop-blur-sm">
                <span className="text-[14px] sm:text-[16px] font-bold text-red-400 tracking-wide">LEXO 슬로건</span>
              </div>

              {/* 메인 타이틀 */}
              <h2 className="text-[56px] sm:text-[80px] lg:text-[100px] font-black text-white mb-6 sm:mb-8 leading-none tracking-tighter">
                강한 일본어
              </h2>

              {/* 서브 타이틀 */}
              <p className="text-[18px] sm:text-[24px] lg:text-[28px] text-gray-300 mb-8 sm:mb-12 leading-relaxed font-medium">
                LEXO와 함께 일본어 실력을 강하게 만드세요
              </p>

              {/* CTA 버튼 */}
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center">
                <a 
                  href="#personal" 
                  className="px-8 sm:px-12 py-4 sm:py-5 bg-gradient-to-r from-red-500 to-red-600 text-white text-[15px] sm:text-[17px] font-bold rounded-xl hover:shadow-2xl hover:shadow-red-500/50 transition-all duration-300 whitespace-nowrap transform hover:scale-105 cursor-pointer"
                >
                  지금 시작하기
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
